import React from 'react';

const Button = ({ children, variant = 'primary', href, onClick, className = '' }) => {
  const baseClass = variant === 'primary' ? 'btn-primary' : 'btn-outline';
  
  if (href) {
    return (
      <a href={href} className={`${baseClass} ${className}`}>
        {children}
      </a>
    );
  }
  
  return (
    <button onClick={onClick} className={`${baseClass} ${className}`}>
      {children}
    </button>
  );
};

export default Button;
